import { type JSX, Show } from "solid-js";

import { getImageAltByLang } from "@/constants/seo-constants";
import { useI18n } from "@/i18n";
import { getImgurl } from "@/lib/resFolder.ts";
import { cn } from "@/lib/tailwindcssTool";

interface Empty {
  text?: string;
  children?: JSX.Element;
  class?: string;
  imgClass?: string;
  textClass?: string;
}
export default function Empty(props: Empty) {
  const { t } = useI18n();
  return (
    <div
      class={cn(
        "flex min-w-[max-content] flex-col items-center justify-center",
        props.class,
      )}
    >
      <img
        src={getImgurl("empty.png", "common/home")}
        class={cn("w-[220px] shrink-0", props.imgClass)}
        alt={getImageAltByLang("userProfileImg")}
      />
      <Show when={!props.children} fallback={props.children}>
        <p
          class={cn(
            "text-general-bright mt-[10px] text-center text-[14px] font-normal",
            props.textClass,
          )}
        >
          {props.text ? props.text : t("common.no_data")}
        </p>
      </Show>
    </div>
  );
}
